import React from "react";
import ReactDOM from "react-dom/client";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../src/CSS/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.css";
import { AuthProvider } from "./authContext";
import { CartProvider } from "./cartContext";
import { FontsProvider } from "./lib/fonts";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <CartProvider>
        <FontsProvider>
          <App />{" "}
        </FontsProvider>
      </CartProvider>
    </AuthProvider>
    <ToastContainer autoClose={1000} pauseOnHover={false} />
  </React.StrictMode>
);
reportWebVitals();
